import React, { Fragment, useEffect } from 'react';
import InputField from "../../Inputs/InputField";
import ErrorLabel from '../../Labels/ErrorLabel';
import Button from '../../Buttons/Button';
import Styles from './UserName.module.scss';
import { AuthOTPState } from "../../../store/authOTP/types";
import { postAuthOTP } from "../../../store/authOTP/thunks";
import { addUserName } from "../../../store/authOTP/actions";
import { FormikProps } from "formik";
import { connect } from "react-redux";
import CardContainer from '../../Card/CardContainer';
import classnames from 'classnames';
import AboutUs from '../../../components/ContentPages/AboutUs.SA';
import { ApiResponse } from '../../../services/types';
import { logout } from '../Auth';

interface UserNameProps {
    nextPage: any,
    formikProps: FormikProps<AuthOTPState>,
    postAuthOTP?: any,
    addUserName?: any,
    validateNumber: any,
    messageResponse: string | React.ReactElement | null
}

const UserName: React.FC<UserNameProps> = (props: UserNameProps) => {

    let errors = props.formikProps.errors;
    let touched = props.formikProps.touched;

    useEffect(() => {
        logout();
    }, []);

    const nextPage = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        let hasBeenTouched = props.formikProps.touched.identification;
            if (hasBeenTouched === undefined) {
                props.formikProps.setFieldTouched("identification");
                return;
            }

        let formIsValid = props.formikProps.errors.identification;
            if (formIsValid !== undefined) {
                return;
            }

        let error = props.formikProps.errors.identification;
            if (error !== undefined) {
                return;
            }

        props.addUserName(props.formikProps.values.identification);
        const response : ApiResponse = await props.postAuthOTP(props.formikProps.values);
        if (response.StatusCode === 200){
            props.nextPage();
        }
    }
    return (
        <Fragment>
            <div className="container">
                <div className={classnames(Styles.marginRow, "row mb-3")}>
                    <div className="col-lg-12 col-sm-12 col-lg-12 col-xs-12">
                        <h5 className={Styles.title}>Bienvenidos a Virtualmente Juntos </h5>
                    </div>
                </div>
                <CardContainer className="col-md-6 col-sm-6 col-lg-5 col-xs-12">
                    <div className="card-body justify-content-center">
                        <div className={Styles.marginRow + " card-title font-weight-bold"}>
                            <h6 className={Styles.color}>Por favor ingresa tu número de Identificacion</h6>
                        </div>
                        <div className={classnames(Styles.marginRow, "row")}>
                            <div className="col-lg-12">
                                <InputField
                                    id="identification"
                                    name="identification"
                                    type="text"
                                    placeholder="Escriba su identificación"
                                    onChange={props.formikProps.handleChange}
                                    onBlur={props.formikProps.handleBlur}
                                    value={props.formikProps.values.identification}
                                    styleClass="form-control"
                                />
                                {touched.identification && errors.identification && <ErrorLabel errorMessage={errors.identification} />}
                                { props.messageResponse }
                           </div>
                        </div>
                        <div className={Styles.marginRow}>
                            <Button
                                id=""
                                onClick={nextPage}
                                styleClass={Styles.size + " largetext"}
                                textoButton="Siguiente" />
                       </div>
                    </div>
                </CardContainer>
                <div className={classnames(Styles.marginRow, "row mt-5")}>
                    <AboutUs classNameStyle="col-md-12 col-sm-12 col-lg-12 col-xs-12" />
                </div>
            </div>
        </Fragment>
    );
};
export default connect( null, {addUserName, postAuthOTP})(UserName);
